import { Absatz } from '../absatz';
import { Umsatz } from '../umsatz';
import { Wetter } from './wetter';

export class Data {
  constructor({
    planAbsatz,
    planUmsatz,
    istUmsatz,
    istAbsatz,
    wetter,
    interneNotiz,
    datum,
  }: {
    readonly interneNotiz: string;
    readonly datum: string;
    readonly planUmsatz?: Umsatz;
    readonly planAbsatz?: Absatz;
    readonly istUmsatz?: Umsatz;
    readonly istAbsatz?: Absatz;
    readonly wetter?: Wetter;
  }) {
    this.istAbsatz = istAbsatz;
    this.planAbsatz = planAbsatz;
    this.istUmsatz = istUmsatz;
    this.planUmsatz = planUmsatz;
    this.wetter = wetter;
    this.interneNotiz = interneNotiz;
    this.datum = datum;
  }

  readonly datum: string;
  readonly interneNotiz: string;
  readonly planUmsatz?: Umsatz;
  readonly istUmsatz?: Umsatz;
  readonly planAbsatz?: Absatz;
  readonly istAbsatz?: Absatz;
  readonly wetter?: Wetter;
}
